import { create } from 'zustand'
import { combine, devtools, persist } from 'zustand/middleware'

export const TimelineTabValue = {
  All: 'all',
  Assessments: 'assessments',
} as const

export type TimelineTabValue =
  (typeof TimelineTabValue)[keyof typeof TimelineTabValue]

export const TasksViewValue = {
  All: 'all',
  AssignedToMe: 'assigned-to-me',
} as const

export type TasksViewValue =
  (typeof TasksViewValue)[keyof typeof TasksViewValue]

interface ParticipantPageState {
  timeline: {
    tabValue: TimelineTabValue
  }
  tasks: {
    view: TasksViewValue
  }
}

const defaultState: ParticipantPageState = {
  timeline: {
    tabValue: TimelineTabValue.All,
  },
  tasks: {
    view: TasksViewValue.All,
  },
}

export const useParticipantPageStore = create(
  devtools(
    persist(
      combine(defaultState, (set) => ({
        setTimelineTabValue: (
          nextTabValue:
            | TimelineTabValue
            | ((current: TimelineTabValue) => TimelineTabValue)
        ) => {
          set((state) => ({
            timeline: {
              ...state.timeline,
              tabValue:
                typeof nextTabValue === 'function'
                  ? nextTabValue(state.timeline.tabValue)
                  : nextTabValue,
            },
          }))
        },
        setTasksView: (
          nextView:
            | TasksViewValue
            | ((current: TasksViewValue) => TasksViewValue)
        ) => {
          set((state) => ({
            tasks: {
              ...state.tasks,
              view:
                typeof nextView === 'function'
                  ? nextView(state.tasks.view)
                  : nextView,
            },
          }))
        },
      })),
      {
        name: 'participant-page',
      }
    )
  )
)

/*
 * @deprecated Use useParticipantPageStore instead
 */
export const useTimelinePageStore = useParticipantPageStore

/*
 * @deprecated Use TimelineTabValue instead
 */
export const TabValues = TimelineTabValue
